import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const RewardsSelectExternalGiftCard = ({
  onBack = () => {},
  onNext = () => {},
  canGoNext,
  inputs,
}) => {
  const { t } = useTranslation(['rewards-gift', 'common'])
  return (
    <div>
      <div className="rewards-modal-content rewards-base-view select-external-card">
        <div className="rewards-modal-input-row">
          {inputs.first && (
            <div className="input-container">
              <div className="input-label">{inputs.first.label}</div>
              {inputs.first.render()}
            </div>
          )}
        </div>
        <div className="rewards-modal-input-row external-cards-container">
          {inputs.second && inputs.second.render()}
        </div>
      </div>
      <div className="rewards-modal-actions">
        <button className="button button-gray" onClick={onBack}>
          {t('common:actions.back')}
        </button>
        <button className="button button-primary" disabled={!canGoNext} onClick={onNext}>
          {t('rewards-gift:sendGiftForm.selectGiftButton')}
        </button>
      </div>
    </div>
  )
}

RewardsSelectExternalGiftCard.propTypes = {
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  canGoNext: PropTypes.bool,
  inputs: PropTypes.object,
}

export default RewardsSelectExternalGiftCard
